import dataTransform from './dataTransform';

export default dataTransform;
